import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formats a ZAR money amount per the CapX style guide (Microcopy & Accessibility):
 *
 *   "ZAR" prefix + space + thousands separator. Never "R" alone (ambiguous),
 *   and a null / unknown amount renders as "—" (em dash), never "N/A" or blank.
 *
 * Amounts arrive from the API as decimal strings (e.g. "250000.00"); whole rands
 * are shown without cents (250,000), fractional amounts keep their cents.
 *
 *   {{ app.amount_requested | zar }}            → "ZAR 250,000"
 *   {{ inv.funded_amount | zar }}               → "—"  (when null)
 *   {{ '1500000.50' | zar }}                    → "ZAR 1,500,000.50"
 */
@Pipe({ name: 'zar', standalone: true, pure: true })
export class ZarPipe implements PipeTransform {
  transform(value: string | number | null | undefined): string {
    if (value === null || value === undefined || value === '') {
      return '—';
    }
    const num = typeof value === 'number' ? value : Number(value);
    if (!Number.isFinite(num)) {
      return '—';
    }
    const hasCents = !Number.isInteger(num);
    // 'en-US' for comma thousands separators, matching the style-guide examples
    // verbatim ("ZAR 250,000") — the en-ZA locale uses spaces, which diverges
    // from the documented canon.
    const formatted = num.toLocaleString('en-US', {
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: 2,
    });
    return `ZAR ${formatted}`;
  }
}
